import { render } from "./AdetGunu.vue?vue&type=template&id=75dbcb1c&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./AdetGunu.vue?vue&type=script&lang=js"
export * from "./AdetGunu.vue?vue&type=script&lang=js"

import "./AdetGunu.vue?vue&type=style&index=0&id=75dbcb1c&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__